export const getInsideInfo = (contentArray) => {
  const infoArray: Array<any> = [];
  for (const contentElement of contentArray) {
    if (contentElement.fields) {
      let infoElement = getObjectFields(contentElement.fields);
      infoElement.createdAt = contentElement.sys ? contentElement.sys.createdAt : "";
      infoElement.updatedAt = contentElement.sys ? contentElement.sys.updatedAt : "";
      infoElement.contentful_id = contentElement.sys ? contentElement.sys.id : "";
      if (infoElement["descripcion"]) infoElement["descripcion"] = {json: infoElement["descripcion"]};
      infoArray.push(infoElement);
    } else {
      infoArray.push(contentElement)
    }
  }
  return infoArray;
}

const getObjectFields = (object) => {
  const auxObject: any = {};
  for (const key in object) {
    if (object[key].fields) {
      auxObject[key] = object[key].fields;
      auxObject[key].createdAt = object[key].sys ? object[key].sys.createdAt : "";
      auxObject[key].updatedAt = object[key].sys ? object[key].sys.updatedAt : "";
      auxObject[key].contentful_id = object[key].sys ? object[key].sys.id : "";
    } else if (Array.isArray(object[key])) {
      auxObject[key] = getInsideInfo(object[key]);
    } else {
      auxObject[key] = object[key];
    }
    if (key === "descripcion") object[key] = {json: object[key]};
  }
  return auxObject;
}